import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { messageFormat } from '@clubmed/utils';
import { momentFromApiDate } from 'Utils/date/apiDate';
import { getWayLabel } from 'Components/widgets/transport-details/transportUtils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
type Props = {
  way: 'INBOUND' | 'OUTBOUND';
  departureFullName: string;
  arrivalFullName: string;
  date: string;
  i18n: CMSContent;
  transportIcon: IconName;
  isInline?: boolean;
};
export const FlightSummary = ({
  way,
  departureFullName,
  arrivalFullName,
  date,
  transportIcon,
  i18n = {},
  isInline = false,
}: Props) => {
  const wayLabel = getWayLabel(i18n, way);
  const flightSummaryLabel = `${i18n?.common?.transport?.from} ${departureFullName} ${i18n?.common?.transport?.to} ${arrivalFullName}`;
  const datePattern = i18n?.common?.transport?.onDate;
  const dateFormated = datePattern
    ? messageFormat(datePattern).format({
        date: `${momentFromApiDate(date).format(i18n?.common?.verboseDateFormatTechnicalID)}`,
      })
    : '';
  const isPlane = transportIcon === ICONS.TRANSPORT;
  const isOutBound = way.toLowerCase() === 'outbound';
  return (
    <div className="flex items-center justify-center gap-20">
      <Icon
        className={classnames('text-saffron', {
          'ltr:-scale-x-1 rtl:scale-x-1': isOutBound,
        })}
        dataTestid={transportIcon || undefined}
        name={transportIcon}
        width={isPlane ? '24px' : '48px'}
      />
      <div className="text-14">
        {isInline ? (
          <p data-testid="FlightSummary-inline">
            {wayLabel}:&nbsp;{`${flightSummaryLabel} ${dateFormated?.toLowerCase()}`}
          </p>
        ) : (
          <Fragment>
            <div data-testid="flight-summary-text">
              {wayLabel}:&nbsp;
              {flightSummaryLabel}
            </div>
            <div data-testid="flight-summary-date">{dateFormated}</div>
          </Fragment>
        )}
      </div>
    </div>
  );
};
